var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"boton-home__container",on:{"click":_vm.onClick}},[_c('SvgIcon',{attrs:{"width":"2.5rem","height":"2.5rem","color":"primary","src":require(`@/assets/svg/sistema/modulos/${_vm.ruta.icon}.svg`)}}),_c('div',{staticClass:"boton-home__text"},[_vm._v(" "+_vm._s(_vm.ruta.text)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }